import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiServices } from "../../service/apiServices";

const namespace = "AttendanceByName";

export const getAttendanceByName = createAsyncThunk(
  `${namespace}/getAttendanceByName`,
  async (body, { rejectWithValue }) => {
    const api = "getAttendanceByName";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getAttendanceExcel = createAsyncThunk(
  `${namespace}/getAttendanceExcel`,
  async ({employeeLists, department, start_date, end_date, start_time, end_time, time}, { rejectWithValue }) => {
    const api = "getAttendanceExcel";
    const opt = {
      body: {
        attendance: employeeLists,
        department,
        start_date,
        end_date,
        start_time, 
        end_time, 
        time
      },
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  searchDetails: {
    fullname: "",
    department: '',
    start_date: "",
    end_date: "",
    start_time: "",
    end_time: "",
    time: ""
  },
  employeeLists: [],
  loading: false,
  error: false,
};

const attendanceByNameSlice = createSlice({
  name: "attendanceByName",
  initialState,
  reducers: {
    updateSearchDetails(state, action) {
      return { ...state, searchDetails: action.payload };
    },
    resetDetails(state, action) {
      return { ...state, 
        searchDetails: initialState.searchDetails,
        employeeLists: initialState.employeeLists
      };
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getAttendanceByName.pending, (state) => {
        state.loading = true;
        state.error = false; // Reset error when starting a new request
      })
      .addCase(getAttendanceByName.fulfilled, (state, action) => {
        state.loading = false;
        state.employeeLists = action.payload; // Set employee lists from the response
      })
      .addCase(getAttendanceByName.rejected, (state, action) => {
        state.loading = false;
        state.error = true; // Set error state
        console.error(action.payload);
      })

      .addCase(getAttendanceExcel.pending, (state) => {
        state.loading = true;
        state.error = false; // Reset error when starting a new request
      })
      .addCase(getAttendanceExcel.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getAttendanceExcel.rejected, (state, action) => {
        state.loading = false;
        state.error = true; // Set error state
        console.error(action.payload);
      });
  },
});

export const { updateSearchDetails, resetDetails } = attendanceByNameSlice.actions;
export default attendanceByNameSlice.reducer;